import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Home, PenSquare, Target, Lightbulb, List, Shield, Users } from 'lucide-react';
import { useMobileMenu } from '../contexts/MobileMenuContext';
import { useAuth } from '../contexts/AuthContext';

export default function MobileNavigation() {
  const { isMainMenuOpen, setIsMainMenuOpen } = useMobileMenu();
  const location = useLocation();
  const { isAdmin } = useAuth();
  const menuRef = React.useRef<HTMLDivElement>(null);
  const buttonRef = React.useRef<HTMLButtonElement>(null);

  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        menuRef.current &&
        buttonRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsMainMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setIsMainMenuOpen]);

  const menuItems = [
    { icon: <Home size={20} />, label: 'Home', to: '/' },
    { icon: <Users size={20} />, label: 'Community', to: '/community' },
    { icon: <PenSquare size={20} />, label: 'Write', to: '/write' },
    { icon: <Lightbulb size={20} />, label: 'Ideas', to: '/ideas' },
    { icon: <List size={20} />, label: 'Set List', to: '/setlist' },
    { icon: <PenSquare size={20} />, label: 'Exercises', to: '/exercises' },
    { icon: <Target size={20} />, label: 'Practice', to: '/practice' }
  ];

  if (isAdmin) {
    menuItems.push({ icon: <Shield size={20} />, label: 'Admin', to: '/admin' });
  }

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        onClick={() => setIsMainMenuOpen(!isMainMenuOpen)}
        className="p-2 rounded-lg hover:bg-black/5 transition-colors"
      >
        <Menu size={24} />
      </button>

      {isMainMenuOpen && (
        <div ref={menuRef} className="fixed left-0 top-[100px] mt-2 w-64 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-[100]">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {menuItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setIsMainMenuOpen(false)}
                className={`flex items-center px-4 py-2 text-sm ${
                  location.pathname === item.to
                    ? 'text-orange-500 bg-orange-50 dark:bg-orange-900/20'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                {item.icon}
                <span className="ml-3">{item.label}</span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
